export const FEATURES = {
  HABIT_TRACKER: 1,
  BODY_HEATMAP: 2,
  WEARABLES_DASHBOARD: 3,
  LOAD_MONITORING_DASHBOARD: 4,
  KPI_TRACKER: 5,
  FORCE_PLATE_DASHBOARD: 6,
  VOLUME_TRACKER: 7,
  VBT_DASHBOARD: 8,
  // Add other features here
};

/**
 * Utility function to check if a feature has been viewed
 * @param {Array} viewedFeatures - List of viewed features from the API
 * @param {Number} featureId - The feature ID to check
 * @returns {Boolean} - True if the feature has been viewed, otherwise false
 */
export const hasViewedFeature = (
  viewedFeatures, featureId,
) => viewedFeatures.some((vf) => vf.featureId === featureId);

/**
 * Utility function to translate path segment to feature ID
 * @param {String} pathSegment - The path segment representing dashboard name
 * @returns {Number} - The dashboard's feature ID
 */
export const dashboardFeatureIdGrabber = (pathSegment) => {
  let featureId;
  let dashboardNameAmplitude;
  switch (pathSegment) {
    case 'wearables-dashboard':
      featureId = FEATURES.WEARABLES_DASHBOARD;
      dashboardNameAmplitude = 'Wearables Dashboard';
      break;
    case 'load-monitoring-dashboard':
      featureId = FEATURES.LOAD_MONITORING_DASHBOARD;
      dashboardNameAmplitude = 'Load Monitoring Dashboard';
      break;
    case 'kpi-tracker':
      featureId = FEATURES.KPI_TRACKER;
      dashboardNameAmplitude = 'Sport Coach Dashboard';
      break;
    case 'body-heatmap':
      featureId = FEATURES.BODY_HEATMAP;
      dashboardNameAmplitude = 'Recovery Radar';
      break;
    case 'habit-tracker':
      featureId = FEATURES.HABIT_TRACKER;
      dashboardNameAmplitude = 'Consistency Coach';
      break;
    case 'force-plate-dashboard':
      featureId = FEATURES.FORCE_PLATE_DASHBOARD;
      dashboardNameAmplitude = 'Force Plate Dashboard';
      break;
    case 'volume-tracker':
      featureId = FEATURES.VOLUME_TRACKER;
      dashboardNameAmplitude = 'Volume Tracker';
      break;
    case 'vbt-dashboard':
      featureId = FEATURES.VBT_DASHBOARD;
      dashboardNameAmplitude = 'VBT';
      break;
    default:
      break;
  }
  return { featureId, dashboardNameAmplitude };
};

/**
 * Utility function to prepare the payload for marking a feature as viewed
 * @param {String} accountCode - The user's account code
 * @param {String} userId - The user's ID
 * @param {Number} featureId - The feature ID to mark as viewed
 * @returns {Object} - The payload to send to the backend
 */
export const createViewedFeaturePayload = (accountCode, userId, featureId) => ({
  accountCode,
  userId,
  featureId,
});
